<template>
    <div class="maxlength" :class="( currentlength > thisMaxlength || currentlength < minlength ? 'error' : '')">
        <textarea
                v-model="thisValue"
                @change="change(thisValue)"
                :id="id" :name="name"
                :maxlength="noLimit ? '' : thisMaxlength"
                :minlength="minlength"
                :placeholder="placeholder"
                :required="required"
                v-on:keyup="getlength(thisValue)">
        </textarea>
        <div class="maxlength__counter"><span class="maxlength__count">{{ currentlength }}</span>/{{ thisMaxlength }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            name: String,
            maxlength: String,
            minlength: {
                type: String,
                default: "0"
            },
            value: String,
            placeholder: String,
            required: {
                type: Boolean,
                default: false
            },
            change: {
                type: Function,
                default: (value) => {}
            },
            noLimit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                thisValue: this.value,
                thisMaxlength: this.maxlength,
                currentlength: 0,
            }
        },
        methods: {
            getlength(val) {
                // let tempVal = val.replace(/\n/g, "\r\n");
                this.currentlength = val.length;
            }
        },
        mounted() {
            this.getlength(this.value);
        }
    }
</script>
